import { render, staticRenderFns } from "./configItemUpdate.vue?vue&type=template&id=5d08dfe2&scoped=true"
import script from "./configItemUpdate.vue?vue&type=script&lang=js"
export * from "./configItemUpdate.vue?vue&type=script&lang=js"
import style0 from "./configItemUpdate.vue?vue&type=style&index=0&id=5d08dfe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d08dfe2",
  null
  
)

export default component.exports